import {CircularProgress} from '@mui/material'
import DataRefetchOnError from '../../common/DataFetchError/DataRefetchOnError'
import MultiSelectDropdownComponent from '../../common/MulitSelectDropdown/MultiSelectDropdownComponent'
import {DropdownLoadingBox} from '../Jurisdiction/JurisdictionStyle'
import {SharedSubTitle} from '../../common/SharedSubTitleStyle'
import loadingTitles from '../../../appConfig/loadingTitles.config.json'
import PropTypes from 'prop-types'
import {StyledSectionTitle} from '../../AdminPanelStyling'
import {useProjectDetails} from '../../../store/hooks/projectDetails'
import {useFilterConfig} from '../../../store/hooks/config'

const EnvironmentalExposureComponent = ({
  selectedData,
  setFilterValue,
  handleOptionDeletion,
  enabled,
  isCompleted,
  showCustomLabels,
  setCustomLabelDialogProps,
  hasAnyFilters
}) => {
  const {filterDetailsLoading, filterDetailsError, refetchFilterDetailsList} = useProjectDetails()
  const filterConfig = useFilterConfig()

  function refetchHealthAndConditions(event) {
    event.preventDefault()
    refetchFilterDetailsList()
  }

  const renderDropdown = () => {
    if (filterDetailsLoading) {
      return (
        <DropdownLoadingBox>
          <CircularProgress title={loadingTitles.environmentExposureBreadcrumb} />
        </DropdownLoadingBox>
      )
    }

    if (!filterDetailsLoading && filterDetailsError) {
      return <DataRefetchOnError onTryAgain={(event) => refetchHealthAndConditions(event)} />
    }

    const environmentalExposureSection = filterConfig?.data?.find((section) => section.id === '7')
    const environmentalExposureKeys = environmentalExposureSection?.filters?.map((filter) => filter.key) || []
    const environmentalExposureFilters =
      environmentalExposureSection?.filters.map((filter) => ({
        title: filter.name,
        FILTER_KEY: filter.key,
        FILTER_ID: filter.key,
        IS_ACTIVE: true
      })) || []

    const sortedHealthCondition = environmentalExposureFilters.sort((a, b) => {
      if (a.title < b.title) return -1
      if (a.title > b.title) return 1
      return 0
    })

    // Predicate to check if filter belongs to Environmental Exposure section
    const isEnvironmentalExposureFilter = (filter) =>
      environmentalExposureKeys.some((key) => filter.FILTER_KEY?.startsWith(key))

    // Filter selectedData to only include Environmental Exposure filters
    const selectedEnvironmentalExposureFilters = selectedData?.filter(isEnvironmentalExposureFilter) || []

    // Wrapper to merge with other filter sections
    const handleEnvironmentalExposureChange = (newFilters) => {
      const otherFilters = selectedData?.filter((filter) => !isEnvironmentalExposureFilter(filter)) || []
      setFilterValue([...otherFilters, ...newFilters])
    }

    return (
      <MultiSelectDropdownComponent
        selectAllTitle='Select All'
        dropDownTitle='Select'
        inputAndPreviewTitle='Environmental Exposure'
        dropDownModifiedTitle='Selected'
        dropDownData={sortedHealthCondition}
        val={selectedEnvironmentalExposureFilters}
        setVal={handleEnvironmentalExposureChange}
        enabled={enabled}
        isCompleted={isCompleted}
        handleOptionDeletion={(type, data, option) => handleOptionDeletion(type, data, option)}
        hasAnyFilters={hasAnyFilters}
        isFilterDropdown={true}
        section='Environmental Exposure'
        setCustomLabelDialogProps={setCustomLabelDialogProps}
        showCustomLabels={showCustomLabels}
      />
    )
  }
  return (
    <>
      <StyledSectionTitle variant='h5'> What Environmental Exposure filters do you want available? </StyledSectionTitle>
      <SharedSubTitle>This is what your client will see when interacting with data on their dashboard</SharedSubTitle>
      {renderDropdown()}
    </>
  )
}

EnvironmentalExposureComponent.propTypes = {
  selectedData: PropTypes.array.isRequired,
  setFilterValue: PropTypes.func.isRequired,
  handleOptionDeletion: PropTypes.func,
  enabled: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  showCustomLabels: PropTypes.bool,
  setCustomLabelDialogProps: PropTypes.func,
  hasAnyFilters: PropTypes.bool
}

export default EnvironmentalExposureComponent
